<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-title class="modal-title">{{'edit_georgian_bar_types' | translate}}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true" class="ion-padding">
  <div class="configuration-container">
    <ng-container class="contentDiv">
      <ion-list>
        <ng-container *ngFor="let obj of barShapesData">
          <ion-item lines="none" class="cardDiv" (click)="selectBarOpt(obj.id)"
            [ngClass]="obj['id'] == selectedBar ? 'selected' : ''" *ngIf="(obj['name'] | translate)?.trim()">
            <div class="image-container">
              <img [src]="obj.img" class="square-image" />
            </div>
            <div class="content-container">
              <h5 class="card-title">{{obj.name | translate}}</h5>
            </div>
          </ion-item>
        </ng-container>
      </ion-list>
    </ng-container>
  </div>
</ion-content>
<ion-footer [translucent]="false" class="ion-no-border ">
  <div class="button-container">
    <ion-button fill="outline" class="cancel-btn" (click)="cancel()" expand="block">
      {{'cancel' | translate}}
    </ion-button>
    <ion-button class="next-btn" (click)="next()" [disabled]="!isFormValid" expand="block">
     {{ (isShowConfiguration ? 'next' : 'validate') | translate }}
    </ion-button>
  </div>
</ion-footer>